import React from 'react';
import { useTranslation } from 'react-i18next';

function Header() {

  const {t} = useTranslation('services');
 
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title"> {t('projects-title')} </h1>
          <div className="text fsz-18 color-666">
            {t('projects-subtitle')}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
